export const modalvideoInit = () => {
    setTimeout(() => {
        try {

            doYT()
            function doYT() {

                if (YT.loaded) {
                    const youtube = document.querySelector("#youtubePlayer")
                    if (youtube)
                        new YT.Player('youtubePlayer', {
                            height: '9',
                            width: '16',
                            videoId: youtube.dataset.id,
                            events: {
                                'onReady': onPlayerReady,
                            }
                        });
                } else {
                    setTimeout(
                        () => {
                            doYT()
                        }, 100
                    )
                }
            }
        } catch (error) {
            console.warn(error)
        }

    }, 500)

    function onPlayerReady(event) {
        event.target.setVolume(0);
        window.youtubeapi = {
            stopvideo: () => {
                event.target.stopVideo();
            },
            startvideo: () => {
                event.target.playVideo();
                event.target.setVolume(50);
            }
        }
    }
}
// 